<!--
 * @Description: (弹框)分账详情组件
 * @Author: wanqian, gaohc
 * @Date: 2022-09-29 16:43:52
-->
<template>
  <el-dialog width="1000px" center title="分账详情" :visible.sync="visible" :close-on-click-modal="false"
    @open="getSharingDetailsDo" :before-close="handleCancel" append-to-body>
    <div class="bk-head" v-if="sharingDTO">
      <el-row :gutter="10" type="flex" justify="space-between" align="center">
        <el-col :span="9">
          <span class="text" style="text-align: left;">
            申请人 ：{{sharingDTO.applyForName ? sharingDTO.applyForName : '- -'}}
          </span>
        </el-col>
        <el-col :span="7">
          <span class="text" style="text-align: center;">
            申请时间 ：{{sharingDTO.applyForTime ? dateFormat(sharingDTO.applyForTime) : '- -'}}
          </span>
        </el-col>
        <el-col :span="8">
          <div style="display: flex; align-items: center; justify-content: flex-end;" class="mouse-pointer" 
            @click="handleOrderDetailsClick">
            <img style="width: 18px; height: 19px;" src="@/assets/finance/sharinglist/icon-sharinglist-order.png" 
              alt="" />
            <div style="margin: 0 4px; font-size: 14px; color: #3A7FF3;">订单与排班详情</div>
            <img style="width: 8px; height: 13px;" src="@/assets/finance/sharinglist/icon-sharinglist-arrow-right-blue.png" 
              alt="" />
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="bk-money">
      <div>
        <div class="sharing-total-money">{{'应分总额 ：' + sharingDTO.sharableAmountYuan}}</div>
        <div class="order-money">
          <div>{{'实付 ：' + sharingDTO.payAmountYuan}}</div>
          <div v-if="sharingDTO.refundAmountYuan" style="display: flex; align-items: center;">
            <div class="div-vline"></div>
            <div>{{'提前结束退款 ：' + sharingDTO.refundAmountYuan}}</div>
          </div>
        </div>
      </div>
      <img v-if="statusImg" class="img-status" :src="statusImg" alt="">
    </div>
    <div class="table-wrap">
      <el-table border ref="table" :data="dataTable" row-key="id"
      header-cell-class-name="table-header-color" :span-method="objectSpanMethod">
      <el-table-column label="类型" min-width="10%" align="center">
        <template slot-scope="scope">{{scope.row.ownerTypeText}}</template>
      </el-table-column>
      <el-table-column label="比例" min-width="10%" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.ownerType == 11">
            {{getSumByKeyUsingForEach(11, 'ratioStr') + '%'}}
          </span>
          <span v-else>
            {{scope.row.ratioStr + '%'}}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="收款方" min-width="15%" align="center">
        <template slot-scope="scope">{{scope.row.owner}}</template>
      </el-table-column>
      <el-table-column label="应分金额（元）" min-width="15%" align="center">
        <template slot-scope="scope">{{scope.row.sharableTotalAmountYuan}}</template>
      </el-table-column>
      <el-table-column label="扣款/补贴（元）" min-width="20%" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.ownerType == 11">
            {{ getSumByKeyUsingForEach(11, 'deductionPerkAmountYuan') != 0 ?
            '服务扣款：' + getSumByKeyUsingForEach(11, 'deductionPerkAmountYuan') : 0 }}
          </span>
          <span v-else>
            {{parseFloat(scope.row.deductionPerkAmountYuan) > 0 
            ? '服务回款：+' + (scope.row.deductionPerkAmountYuan) :
            parseFloat(scope.row.deductionPerkAmountYuan) < 0 ?
            '服务扣款：' + (scope.row.deductionPerkAmountYuan) : 0}}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="实分金额（元）" min-width="15%" align="center">
        <template slot-scope="scope">{{scope.row.sharingTotalAmountYuan}}</template>
      </el-table-column>
      <el-table-column v-if="sharingDTO.status != 3" label="分账到" min-width="15%" align="center">
        <template slot-scope="scope">{{scope.row.accountTypeText}}</template>
      </el-table-column>
    </el-table>
    </div>
    <div class="div-notes">
      <span>备注：</span>
      <span style="white-space: pre-line;">{{sharingDTO.remark ? sharingDTO.remark : '- -'}}</span>
    </div>
    <div class="dialog-footer bk-wizard-bottons">
      <el-button @click="handleCancel">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Constant from '@/global/Constant.js'

export default {
  name: 'SharingDetails',

  props: ["visible", 'orderId', 'sharingId'],

  data() {
    return {
      sharingDTO: {},
      dataTable: [],
      servicerFlagObj: {startIndex: 0, length: 0}
    }
  },

  computed: {
    statusImg() {
      if (this.sharingDTO.status == 3) {
        return require('@/assets/finance/sharinglist/img-finance-sharinglist-fail.png');
      } else if (this.sharingDTO.status == 2) {
        return require('@/assets/finance/sharinglist/img-finance-sharinglist-success.png');
      }
      return require('@/assets/finance/sharinglist/img-finance-sharinglist-wait-sharing.png');
    }
  },
  
  methods:{
    getSharingDetailsDo() {
      let param = {id: this.sharingId};
      let header = this.encryptionUtil.signatureParams(param,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_REVENUE_SHARING_DETAILS,
        param: param,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
     	this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.sharingDTO = result.data;
          this.dataTable = result.data.revenueSharingItemList;
          this.getFlagObjMessage("servicerFlagObj");
        }
      })
    },

    getSumByKeyUsingForEach(val, key) {
      let sum = 0;
      this.dataTable.forEach(obj => {
         if (obj.ownerType == val) {
          sum += parseFloat(obj[key]) || 0;
         }
      });
      return Number(sum).toFixed(2);
    },

    // 获取详情集合中收款方类型是其他人的信息，包括起始下标，以及长度
    getFlagObjMessage(flagObj) {
      let startIndex = -1;
      let totalLength = 0;
      this.dataTable.forEach((item, index) => {
        // 收款方类型：1-本平台 2-机构 3-代理 10-派单人 11-服务人 20-其他人
				if (item.ownerType == (flagObj == 'servicerFlagObj' ? 11 : 20)) {
          if (startIndex == -1) { startIndex = index; }
          totalLength += 1;
        }
			})
      this[flagObj] = {'startIndex': startIndex, 'length': totalLength};
    },

    handleOrderDetailsClick() {
      this.$emit('check-order-detail', this.orderId);
    },

    handleCancel() {
      this.$emit("close-dialog", false);
    },

    // 合并行或列
    objectSpanMethod({_row, _column, rowIndex, columnIndex}) {
      // 合并第一列、第二列、第五列类型为其他人的行，如果没有其他人类型/其他列则返回
      if ((columnIndex != 0 && columnIndex != 1 && columnIndex != 4) || !this.servicerFlagObj.length) return;
      // 1代表单独占一行，更大的自然数代表合并了若干行，0代表“消失”的哪那一个单元格，后面的单元格向前推一格
      if (rowIndex == this.servicerFlagObj.startIndex) {
        return [this.servicerFlagObj.length, 1];
      } else if (rowIndex > this.servicerFlagObj.startIndex 
        && rowIndex < (this.servicerFlagObj.startIndex + this.servicerFlagObj.length)) {
        return [0, 1];
      } else {
        return [1, 1];
      }
    },

    dateFormat(date) {
      return this.dateUtil.dateTimeFormat(date, "YYYY-MM-DD HH:mm");
    }
  }
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}
.bk-head {
  padding: 26px 25px;
  margin: 0 25px;
  background-color: #F7F9FE;
}
.bk-head .text {
  font-size: 14px;
  color: #525254;
  line-height: 19px;
}
.bk-head .text-blue {
  color: #3E7EF5;
}
.bk-money {
  position: relative;
  margin-top: 16px;
  padding: 0 50px;
  display: flex;
  justify-content: space-between;
}
.bk-money .sharing-total-money {
  font-size: 15px;
  color: #333333;
  line-height: 20px;
}
.bk-money .order-money {
  margin-top: 14px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #606266;
  line-height: 19px;
}
.div-vline {
  margin: 0 20px;
  width: 1px;
  height: 15px;
  background-color: #D7DDE5;
}
.img-status {
  width: 100px;
  height: 100px;
  position: absolute;
  top: -30px;
  right: 34px;
}
.table-wrap {
  padding: 16px 25px 0 25px;
}
.div-notes {
  margin: 20px 25px 0 25px;
  background: #F7F9FE;
  border-radius: 4px;
  padding: 18px 20px;
  font-size: 14px;
  color: #525254;
  line-height: 19px;
}
.dialog-footer {
  margin-top: 40px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/finance/components/sharinglist/SharingDetails.vue